module.exports = __webpack_public_path__ + "img/shirt-tank-top.e173fab6.svg";